import { takeEvery } from 'redux-saga/effects'

export function* worker({ payload }) {
  yield localStorage.setItem('sovCurrentNavTab', payload)
}

export default function* setNavTabToLocalstorage() {
  yield takeEvery('NAVMENU_SET_CURRENT_TAP', worker)
}
